import { render } from "./ExchangeBanner.vue?vue&type=template&id=0c596066&scoped=true"
import script from "./ExchangeBanner.vue?vue&type=script&lang=js"
export * from "./ExchangeBanner.vue?vue&type=script&lang=js"

import "./ExchangeBanner.vue?vue&type=style&index=0&id=0c596066&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c596066"]])

export default __exports__